module.exports = __webpack_public_path__ + "static/media/8_angel_horse.2120664a.png";